<section class="atw-page policies-page">
  <span class="shape shape-1"></span>
  <span class="shape shape-2"></span>
  <span class="dots dots-left"></span>
  <span class="dots dots-right"></span>

  <div class="atw-container">

    <!-- Hero -->
    <div class="policies-hero">
      <div class="policies-hero-content">
        <div class="hero-badge">
          <span>{{ 'atw.policies.hero.badgeNumber' | transloco }}</span>
          {{ 'atw.policies.hero.badgeTitle' | transloco }}
        </div>

        <h1>
          {{ 'atw.policies.hero.titleLine1' | transloco }}
          <strong>{{ 'atw.policies.hero.titleStrong' | transloco }}</strong>
        </h1>

        <p>
          {{ 'atw.policies.hero.description' | transloco }}
        </p>

        <div class="hero-actions">
          <a class="primary-action" href="#policies-list">

            {{ 'atw.policies.hero.primaryBtn' | transloco }}
          </a>

          <a class="secondary-action" routerLink="/contact-us">

            {{ 'atw.policies.hero.secondaryBtn' | transloco }}
                        <img class="img-m" src="assets/as/25.webp" alt="help" />
          </a>
        </div>
      </div>

      <div class="policies-hero-visual">
        <div class="policies-visual-card">
          <div class="policies-visual-icon">
            <img class="img-l" src="assets/as/37.webp" alt="policies" />
          </div>

          <strong>{{ 'atw.policies.hero.visualTitle' | transloco }}</strong>
          <p>{{ 'atw.policies.hero.visualText' | transloco }}</p>

          <div class="policy-doc-lines">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>

        <div class="floating-card policies-floating-card">
          <img class="img-m" src="assets/as/36.webp" alt="protection" />

          <div>
            <strong>{{ 'atw.policies.hero.floatTitle' | transloco }}</strong>
            <small>{{ 'atw.policies.hero.floatText' | transloco }}</small>
          </div>
        </div>
      </div>
    </div>

    <!-- Mini Cards -->
    <section class="apply-section">
      <div class="policies-mini-grid">
        <div class="apply-card policy-mini-card">
          <img class="img-m" src="assets/as/37.webp" alt="privacy" />

          <div>
            <strong>{{ 'atw.policies.stats.privacy.title' | transloco }}</strong>
            <p>{{ 'atw.policies.stats.privacy.text' | transloco }}</p>
          </div>
        </div>

        <div class="apply-card policy-mini-card">
          <img class="img-m" src="assets/as/12.webp" alt="cv" />

          <div>
            <strong>{{ 'atw.policies.stats.cv.title' | transloco }}</strong>
            <p>{{ 'atw.policies.stats.cv.text' | transloco }}</p>
          </div>
        </div>

        <div class="apply-card policy-mini-card">
          <img class="img-m" src="assets/as/26.webp" alt="usage" />

          <div>
            <strong>{{ 'atw.policies.stats.usage.title' | transloco }}</strong>
            <p>{{ 'atw.policies.stats.usage.text' | transloco }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- Policies List -->
    <section class="apply-section" id="policies-list">
      <div class="section-title">
        <span>
          <b>{{ 'atw.policies.list.sectionNumber' | transloco }}</b>
        </span>

        <div>
          <h2>{{ 'atw.policies.list.title' | transloco }}</h2>
          <p>{{ 'atw.policies.list.subtitle' | transloco }}</p>
        </div>
      </div>

      <div class="apply-card policies-tools">
        <label class="policies-search">
          <span>{{ 'atw.policies.filters.searchLabel' | transloco }}</span>

          <input
            type="text"
            [value]="searchTerm"
            (input)="onSearch($event)"
            [placeholder]="'atw.policies.filters.searchPlaceholder' | transloco"
          />
        </label>

        <div class="policies-categories">
          <button
            type="button"
            *ngFor="let category of categories; trackBy: trackByCategory"
            class="policy-filter-btn"
            [class.active]="activeCategory === category.id"
            (click)="setCategory(category.id)"
          >
            {{ category.labelKey | transloco }}
          </button>
        </div>
      </div>

      <div class="policies-layout" *ngIf="filteredPolicies.length; else emptyPolicies">
        <div class="policies-list">
          <article
            class="policy-item"
            *ngFor="let policy of filteredPolicies; trackBy: trackByPolicy"
            [class.open]="isOpen(policy.id)"
          >
            <button
              type="button"
              class="policy-question"
              [attr.aria-expanded]="isOpen(policy.id)"
              (click)="togglePolicy(policy.id)"
            >
              <span class="policy-icon">
                <img
                  class="img-m"
                  [src]="policy.iconImg"
                  [alt]="policy.titleKey | transloco"
                />
              </span>

              <span class="policy-title-wrap">
                <strong>{{ policy.titleKey | transloco }}</strong>
                <small>{{ policy.summaryKey | transloco }}</small>
              </span>

              <span class="policy-state">
                {{ isOpen(policy.id) ? '−' : '+' }}
              </span>
            </button>

            <div class="policy-answer" *ngIf="isOpen(policy.id)">
              <ul>
                <li *ngFor="let pointKey of policy.points; trackBy: trackByPoint">
                  {{ pointKey | transloco }}
                </li>
              </ul>
            </div>
          </article>
        </div>

        <aside class="apply-card policies-side-card">
          <span>{{ 'atw.policies.side.badge' | transloco }}</span>

          <h3>{{ 'atw.policies.side.title' | transloco }}</h3>
          <p>{{ 'atw.policies.side.text' | transloco }}</p>

          <div class="policy-updated-box">
            <small>{{ 'atw.policies.side.lastUpdatedLabel' | transloco }}</small>
            <strong>{{ 'atw.policies.side.lastUpdatedValue' | transloco }}</strong>
          </div>


        </aside>
      </div>

      <ng-template #emptyPolicies>
        <div class="apply-card policies-empty">
          <div>
            <img class="img-m" src="assets/as/2.webp" alt="search" />
          </div>

          <h3>{{ 'atw.policies.empty.title' | transloco }}</h3>
          <p>{{ 'atw.policies.empty.text' | transloco }}</p>

          <button type="button" class="primary-action" (click)="resetFilters()">
            <span>↺</span>
            {{ 'atw.policies.empty.btn' | transloco }}
          </button>
        </div>
      </ng-template>
    </section>

    <!-- CTA -->
    <section class="apply-section">
      <div class="apply-card policies-cta">
        <div>
          <span>{{ 'atw.policies.cta.badge' | transloco }}</span>

          <h2>{{ 'atw.policies.cta.title' | transloco }}</h2>
          <p>{{ 'atw.policies.cta.text' | transloco }}</p>
        </div>

        <a class="primary-action" routerLink="/contact-us">

          {{ 'atw.policies.cta.btn' | transloco }}
        </a>
      </div>
    </section>

  </div>
</section>